import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
} from "firebase/firestore";

function WagerUsers() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const q = query(
        collection(db, "users"),
        orderBy("wager", "desc"), // 🔥 highest first
        limit(20) // 🔥 only 20
      );

      const snap = await getDocs(q);

      const list = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      setUsers(list);

    } catch (e) {
      console.error(e);
    }
  };

  // 🔍 SEARCH
  const filtered = users.filter((u) => {
    const s = search.toLowerCase();

    return (
      (u.name || "").toLowerCase().includes(s) ||
      (u.email || "").toLowerCase().includes(s) ||
      (u.id || "").toLowerCase().includes(s)
    );
  });

  return (
    <div style={container}>
      <h1 style={title}>🎯 Top Wager Users</h1>

      {/* SEARCH */}
      <input
        placeholder="🔍 Search name / email / UID"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={searchBox}
      />

      {/* LIST */}
      <div style={grid}>
        {filtered.map((u, i) => (
          <div key={u.id} style={card}>
            
            <h3>
              #{i + 1} {u.name || "User"}
            </h3>

            <p style={email}>{u.email}</p>

            <p>🆔 {u.id}</p>

            <p style={wager}>🎯 Wager: ₹{u.wager || 0}</p>

            <p>💼 Wallet: ₹{u.wallet || 0}</p>

            <p>
              🧮 Total: ₹{(u.wager || 0) + (u.wallet || 0)}
            </p>

          </div>
        ))}
      </div>
    </div>
  );
}

/* 🔥 STYLES */

const container = {
  padding: 20,
  color: "white",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
  minHeight: "100vh",
};

const title = {
  marginBottom: 20,
};

const searchBox = {
  width: "100%",
  padding: 10,
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.1)",
  background: "#1A1F2E",
  color: "#fff",
  marginBottom: 20,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 20,
};

const card = {
  background: "#1A1F2E",
  padding: 16,
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.05)",
};

const email = {
  fontSize: 12,
  opacity: 0.6,
};

const wager = {
  marginTop: 10,
  fontWeight: "bold",
  color: "#22c55e",
};

export default WagerUsers;